var React = require('react');

function ArrowClose (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.5 -7.43094e-07L0.138784 9.75L14.8612 9.75L7.5 -7.43094e-07Z","fill":"#C4C4C4"}));
}

ArrowClose.defaultProps = {"width":"15","height":"10","viewBox":"0 0 15 10","fill":"none"};

module.exports = ArrowClose;

ArrowClose.default = ArrowClose;
